(function(win, doc) {
  change();

  function change() {
    doc.documentElement.style.fontSize =
      doc.documentElement.clientWidth * 14.5 / 375 + "px";
  }
  win.addEventListener("resize", change, false);
  win.addEventListener("orientationchange", change, false);

})(window, document);




// WEBPACK FOOTER //
// ./src/assets/js/common.js